export default function SignalChipsCard({ title, subtitle, items, tone = "good" }) {
  return (
    <div className="rtv2-card">
      <div className="rtv2-card-head">
        <div>
          <h3>{title}</h3>
          <span className="sub">{subtitle}</span>
        </div>
      </div>
      <div className="rtv2-chip-list">
        {items.map((it) => (
          <span key={it.title} className={`rtv2-chip ${tone}`}>
            <b>{it.title}</b>
            <small>{it.meta}</small>
          </span>
        ))}
      </div>
    </div>
  );
}
